export const MODIFY_TUTORIAL_STEP = 'MODIFY_TUTORIAL_STEP';

export function modifyTutorialStep(tutorialStep){
    return{
        type: MODIFY_TUTORIAL_STEP,
        mainState: {
            tutorialStep: tutorialStep
        }
    }
}